import { Asset } from "./types";

export function formatBytes(bytes: number) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(value >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
}

export function buildAssetUrl(asset: Asset) {
  const base = (
    process.env.NEXT_PUBLIC_MEDIA_PUBLIC_BASE_URL || "/api/storage"
  ).replace(/\/+$/, "");
  return `${base}/${asset.storageKey.replace(/^\/+/, "")}`;
}

export function matchesAccept(asset: Asset, accept?: string[]) {
  if (!accept || accept.length === 0) return true;
  const mime = asset.mimeType?.toLowerCase() || "";
  const ext = (asset.extension || "").toLowerCase().replace(/^\./, "");
  const media = (asset.mediaType || "").toLowerCase();

  return accept.some((ruleRaw) => {
    const rule = ruleRaw.toLowerCase();
    if (!rule) return false;
    if (rule === media) return true;
    if (rule === ext) return true;
    if (rule.startsWith(".")) return ext === rule.replace(/^\./, "");
    if (rule.endsWith("/*")) return mime.startsWith(rule.replace("/*", "/"));
    if (rule.includes("/")) return mime === rule;
    return false;
  });
}

export function matchesPickerAsset(
  asset: Asset,
  accept?: string[],
  showMainImages = false,
) {
  const isImage =
    asset.mediaType?.toLowerCase() === "image" ||
    asset.mimeType?.toLowerCase().startsWith("image/");

  return (
    matchesAccept(asset, accept) &&
    (!isImage || showMainImages || Boolean(asset.variantOfId))
  );
}
